module.exports = __webpack_public_path__ + "static/media/bgr-gold-lg.002bdf6b.webp";